/*
 * Sample master data for the prototype (P1).
 *
 * Every list here becomes a per-company table the company maintains under
 * Settings, so two companies can sell, qualify and lose deals in different
 * words. Screens read these lists instead of hard-coding values; when the API
 * arrives each export is replaced by a call to it, with the same shape.
 */

// The CRM tenant the prototype signs in to: Demulla, the company behind DeeHr360 and the Demulla LMS.
export const company = {
  name: "Demulla Investment Ltd",
  code: "CRM001",
  currency: "KES",
  timezone: "Africa/Nairobi",
  country: "Kenya",
};

export const departments = [
  { id: 1, code: "SAL", name: "Sales", head: "Brian Otieno" },
  { id: 2, code: "CS", name: "Customer Success", head: "Grace Njeri" },
  { id: 3, code: "IMP", name: "Implementation", head: "Kevin Mwangi" },
  { id: 4, code: "SUP", name: "Support", head: "Faith Achieng" },
  { id: 5, code: "MKT", name: "Marketing", head: "Dennis Kiprop" },
  { id: 6, code: "FIN", name: "Finance", head: "Mercy Wambui" },
];

export const teams = [
  { id: 1, name: "Nairobi Enterprise", department_id: 1, lead: "Brian Otieno" },
  { id: 2, name: "SME Desk", department_id: 1, lead: "Ann Mutua" },
  { id: 3, name: "Coast & Western", department_id: 1, lead: "Peter Ouma" },
  { id: 4, name: "Implementation Squad A", department_id: 3, lead: "Kevin Mwangi" },
  { id: 5, name: "Customer Success", department_id: 2, lead: "Grace Njeri" },
  { id: 6, name: "Service Desk", department_id: 4, lead: "Faith Achieng" },
  { id: 7, name: "Growth Marketing", department_id: 5, lead: "Dennis Kiprop" },
];

// Staff (P1.4). Users sign in; staff own work. One person is usually both.
export const staff = [
  { id: 1, staff_no: "STF-001", name: "Jane Wanjiku", role: "Sales Manager", team_id: 1, supervisor: "Brian Otieno", status: "active" },
  { id: 2, staff_no: "STF-002", name: "Brian Otieno", role: "Head of Sales", team_id: 1, supervisor: "—", status: "active" },
  { id: 3, staff_no: "STF-003", name: "Ann Mutua", role: "Sales", team_id: 2, supervisor: "Brian Otieno", status: "active" },
  { id: 4, staff_no: "STF-004", name: "Peter Ouma", role: "Sales", team_id: 3, supervisor: "Brian Otieno", status: "active" },
  { id: 5, staff_no: "STF-005", name: "Lucy Chebet", role: "Sales", team_id: 2, supervisor: "Ann Mutua", status: "active" },
  { id: 6, staff_no: "STF-006", name: "Kevin Mwangi", role: "Implementation", team_id: 4, supervisor: "—", status: "active" },
  { id: 7, staff_no: "STF-007", name: "Grace Njeri", role: "Customer Success", team_id: 5, supervisor: "—", status: "active" },
  { id: 8, staff_no: "STF-008", name: "Faith Achieng", role: "Support", team_id: 6, supervisor: "Grace Njeri", status: "active" },
  { id: 9, staff_no: "STF-009", name: "Dennis Kiprop", role: "Marketing", team_id: 7, supervisor: "—", status: "active" },
  { id: 10, staff_no: "STF-010", name: "Samuel Kariuki", role: "Customer Success", team_id: 5, supervisor: "Grace Njeri", status: "active" },
  { id: 11, staff_no: "STF-011", name: "Mercy Wambui", role: "Finance", team_id: null, supervisor: "—", status: "active" },
  { id: 12, staff_no: "STF-012", name: "Tom Barasa", role: "Sales", team_id: 3, supervisor: "Peter Ouma", status: "inactive" },
];

export const salesPeople = staff.filter((s) => ["Sales", "Sales Manager", "Head of Sales"].includes(s.role) && s.status === "active");

export const locations = [
  { id: 1, country: "Kenya", county: "Nairobi", town: "Westlands", territory: "Nairobi Enterprise", region: "Central" },
  { id: 2, country: "Kenya", county: "Nairobi", town: "Upper Hill", territory: "Nairobi Enterprise", region: "Central" },
  { id: 3, country: "Kenya", county: "Mombasa", town: "Nyali", territory: "Coast", region: "Coast" },
  { id: 4, country: "Kenya", county: "Kisumu", town: "Milimani", territory: "Western", region: "Western" },
  { id: 5, country: "Kenya", county: "Nakuru", town: "Nakuru CBD", territory: "Rift", region: "Rift Valley" },
  { id: 6, country: "Kenya", county: "Kiambu", town: "Thika", territory: "Nairobi Enterprise", region: "Central" },
  { id: 7, country: "Uganda", county: "Kampala", town: "Kololo", territory: "Uganda", region: "East Africa" },
];

export const industries = ["Banking & Finance", "SACCO", "Insurance", "Manufacturing", "Retail", "Healthcare", "Education", "Logistics", "Hospitality", "NGO", "Government", "Agriculture"];

export const segments = [
  { code: "SME", name: "SME", rule: "Under 50 staff" },
  { code: "MID", name: "Mid-market", rule: "50–250 staff" },
  { code: "ENT", name: "Enterprise", rule: "Over 250 staff" },
  { code: "STR", name: "Strategic", rule: "Named accounts" },
];

export const leadSources = ["Website", "Referral", "Google Ads", "LinkedIn", "Event", "Outbound call", "Agent / Partner", "Existing customer", "Walk-in"];

/*
 * The software Demulla supports — the things its support clients use. Two
 * deployment types, both first-class in Support → Connected apps:
 *
 *   platform    Multi-tenant: one service hosting many client companies, each
 *               a tenant with a tenant code (DEE014 on DeeHr360, LMS003 on the
 *               LMS) and a sign-in address. Every tenant is a CRM customer. One
 *               platform connection per product and environment carries all
 *               tenants' tickets; each ticket names its tenant code and the CRM
 *               resolves the customer.
 *   standalone  A single installation serving one client — a bespoke system
 *               built for that customer, or a legacy single-client deployment.
 *               Its connection is bound to that one client at registration.
 *
 * status: active | in_development | retired. Only active products that are
 * sellable can be sold (quotes, prospects, opportunities, demos); bespoke and
 * legacy systems are supported but not offered to anyone else, and
 * in_development ones show in Settings and on the roadmap only.
 */
export const products = [
  { id: 1, code: "HRM", name: "DeeHr360 HR & Payroll", short: "DeeHr360 HRM", owner: "Kevin Mwangi", status: "active", deployment: "platform", domain: "deehr360.com", tenant_prefix: "DEE" },
  { id: 2, code: "LMS", name: "Demulla Loan Management (LMS)", short: "Demulla LMS", owner: "Brian Otieno", status: "active", deployment: "platform", domain: "demullalms.com", tenant_prefix: "LMS" },
  { id: 3, code: "ACC", name: "Demulla Enterprise Accounting", short: "Enterprise Accounting", owner: "Mercy Wambui", status: "in_development", deployment: "platform", domain: "demullaaccounts.com", tenant_prefix: "ACC", expected: "2027" },
  { id: 4, code: "KFT", name: "Kilimo Fresh Export Tracker", short: "Export Tracker", owner: "Kevin Mwangi", status: "active", deployment: "standalone", sellable: false, bespoke: true, note: "Bespoke system built for Kilimo Fresh Exporters" },
  { id: 5, code: "HRM-OP", name: "DeeHr360 HRM on-premise (legacy)", short: "HRM on-premise", owner: "Kevin Mwangi", status: "active", deployment: "standalone", sellable: false, note: "Legacy single-client install, no longer sold; clients move to the platform at renewal" },
];

export const productStatuses = [
  { key: "active", name: "Active", tone: "success" },
  { key: "in_development", name: "In development", tone: "info" },
  { key: "retired", name: "Retired", tone: "secondary" },
];
export const productStatus = (key) => productStatuses.find((s) => s.key === key) ?? { key, name: key, tone: "secondary" };
export const deploymentLabel = (d) => ({ platform: "Multi-tenant platform", standalone: "Standalone application" })[d] ?? d;
export const deploymentTone = (d) => ({ platform: "primary", standalone: "purple" })[d] ?? "secondary";
export const isSellable = (p) => p?.status === "active" && p?.sellable !== false;
export const sellableProducts = products.filter(isSellable);

/*
 * HRM is priced per tenant by employee band; LMS per tenant by the loan book
 * it carries (bands above what the package includes); standalone systems carry
 * a per-installation support contract;
 * Accounting packages are drafted but not on sale while the product is built.
 */
export const packages = [
  { id: 1, product_id: 1, name: "Basic", price: 25000, per: "month", users: 50, unit: "per tenant, up to 50 employees", sellable: true },
  { id: 2, product_id: 1, name: "Standard", price: 60000, per: "month", users: 200, unit: "per tenant, up to 200 employees", sellable: true },
  { id: 3, product_id: 1, name: "Advanced", price: 120000, per: "month", users: 1000, unit: "per tenant, up to 1,000 employees", sellable: true },
  { id: 4, product_id: 2, name: "Standard", price: 85000, per: "month", users: 25, unit: "per tenant, loan book up to KES 100M", sellable: true },
  { id: 5, product_id: 2, name: "Enterprise", price: 180000, per: "month", users: 100, unit: "per tenant, loan book up to KES 500M", sellable: true },
  { id: 6, product_id: 2, name: "Loan-book band", price: 15000, per: "month", users: 0, unit: "per extra KES 100M of loan book", sellable: true },
  { id: 7, product_id: 3, name: "Standard (draft)", price: 30000, per: "month", users: 10, unit: "per tenant", sellable: false },
  { id: 8, product_id: 3, name: "Enterprise (draft)", price: 75000, per: "month", users: 40, unit: "per tenant, multi-entity", sellable: false },
  { id: 9, product_id: 4, name: "Support & maintenance", price: 45000, per: "month", users: 30, unit: "per installation (bespoke contract)", sellable: false },
  { id: 10, product_id: 5, name: "Legacy support", price: 35000, per: "month", users: 300, unit: "per installation (on-premise)", sellable: false },
];

export const competitors = [
  { id: 1, name: "SageHR", product: "Sage People", category: "HR & Payroll" },
  { id: 2, name: "Zoho", product: "Zoho People / Books", category: "HR & Accounting" },
  { id: 3, name: "Musoni", product: "Musoni loan system", category: "Loan management" },
  { id: 4, name: "In-house / Excel", product: "Spreadsheets", category: "Manual" },
  { id: 5, name: "Odoo", product: "Odoo ERP", category: "ERP" },
];

/*
 * Status catalogue (P1.11). A company can rename a stage, add its own and
 * reorder them; the `kind` is what the system relies on, so "Won" stays won
 * whatever it is called.
 */
export const prospectStages = [
  { key: "new", name: "New", kind: "open", order: 1 },
  { key: "contacted", name: "Contacted", kind: "open", order: 2 },
  { key: "interested", name: "Interested", kind: "open", order: 3 },
  { key: "qualified", name: "Qualified", kind: "open", order: 4 },
  { key: "converted", name: "Converted to Lead", kind: "won", order: 5 },
  { key: "nurture", name: "Nurture / On hold", kind: "paused", order: 90 },
  { key: "disqualified", name: "Disqualified", kind: "lost", order: 99 },
];

export const leadStages = [
  { key: "new", name: "New", kind: "open", order: 1 },
  { key: "contacted", name: "Contacted", kind: "open", order: 2 },
  { key: "qualified", name: "Qualified", kind: "open", order: 3 },
  { key: "converted", name: "Opportunity created", kind: "won", order: 4 },
  { key: "lost", name: "Lost", kind: "lost", order: 99 },
];

// Probability by stage (P4.7) is set per company.
export const pipelineStages = [
  { key: "qualified", name: "Qualified", probability: 10, kind: "open", order: 1, max_days: 7 },
  { key: "discovery", name: "Discovery", probability: 20, kind: "open", order: 2, max_days: 14 },
  { key: "demo", name: "Demo", probability: 35, kind: "open", order: 3, max_days: 14 },
  { key: "proposal", name: "Proposal", probability: 50, kind: "open", order: 4, max_days: 21 },
  { key: "negotiation", name: "Negotiation", probability: 70, kind: "open", order: 5, max_days: 21 },
  { key: "contract", name: "Contract", probability: 90, kind: "open", order: 6, max_days: 14 },
  { key: "won", name: "Won", probability: 100, kind: "won", order: 7 },
  { key: "lost", name: "Lost", kind: "lost", probability: 0, order: 99 },
];

// What a prospect must show before it may become a lead (P3 MVP logic).
export const prospectQualification = [
  { key: "contact", label: "Contact details complete (name, phone, email)", required: true },
  { key: "need", label: "Need or product interest identified", required: true },
  { key: "engagement", label: "At least one logged interaction", required: true },
  { key: "owner", label: "Owner assigned", required: true },
  { key: "decision_maker", label: "Decision-maker access confirmed", required: true },
  { key: "fit", label: "Product fit confirmed", required: true },
  { key: "budget_hint", label: "Indicative budget discussed", required: false },
];

// Lead qualification (P4.3). Which are mandatory is a company setting.
export const leadQualification = [
  { key: "need", label: "Customer need", required: true },
  { key: "pain_point", label: "Pain point", required: true },
  { key: "budget", label: "Budget", required: true },
  { key: "decision_maker", label: "Decision maker", required: true },
  { key: "timeline", label: "Purchase timeline", required: true },
  { key: "current_solution", label: "Current solution", required: false },
  { key: "competitors", label: "Competitors in play", required: false },
];

/*
 * Reason codes (P1.12), two levels: a category for reporting, a reason for
 * the detail. `applies_to` says at which points it may be chosen, and the
 * flags say what else must be captured with it.
 */
export const reasonCategories = [
  { key: "fit", name: "No need / poor fit", tone: "secondary" },
  { key: "price", name: "Budget / price", tone: "warning" },
  { key: "timing", name: "Timing", tone: "info" },
  { key: "competitor", name: "Lost to competitor", tone: "danger" },
  { key: "contact", name: "Unresponsive / no access", tone: "dark" },
  { key: "solution", name: "Already has a solution", tone: "primary" },
  { key: "product", name: "Product gap", tone: "purple" },
  { key: "data", name: "Bad or duplicate data", tone: "light" },
  { key: "service", name: "Service / support issues", tone: "danger" },
  { key: "business", name: "Business change", tone: "secondary" },
  { key: "other", name: "Other", tone: "light" },
];

export const reasonCodes = [
  { code: "FIT-01", category: "fit", name: "Too small for our product", applies_to: ["prospect", "lead"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "FIT-02", category: "fit", name: "Industry not served", applies_to: ["prospect", "lead"], needs_competitor: false, recyclable: false, preventable: false },
  { code: "FIT-03", category: "fit", name: "No real need identified", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "PRC-01", category: "price", name: "No budget this year", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "PRC-02", category: "price", name: "Price too high", applies_to: ["lead", "opportunity", "churn", "exit"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "TIM-01", category: "timing", name: "Not ready – revisit later", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "TIM-02", category: "timing", name: "Locked in an existing contract", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "CMP-01", category: "competitor", name: "Chose a competitor on price", applies_to: ["opportunity", "exit"], needs_competitor: true, recyclable: true, preventable: true },
  { code: "CMP-02", category: "competitor", name: "Chose a competitor on features", applies_to: ["opportunity", "exit"], needs_competitor: true, recyclable: true, preventable: true },
  { code: "CON-01", category: "contact", name: "No response after 5 attempts", applies_to: ["prospect", "lead"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "CON-02", category: "contact", name: "Cannot reach decision maker", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "SOL-01", category: "solution", name: "Happy with current system", applies_to: ["prospect", "lead", "opportunity"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "PRD-01", category: "product", name: "Missing required feature", applies_to: ["lead", "opportunity", "churn", "exit"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "PRD-02", category: "product", name: "Integration not supported", applies_to: ["opportunity", "exit"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "DAT-01", category: "data", name: "Duplicate record", applies_to: ["prospect", "lead"], needs_competitor: false, recyclable: false, preventable: false },
  { code: "DAT-02", category: "data", name: "Invalid / fake contact", applies_to: ["prospect", "lead"], needs_competitor: false, recyclable: false, preventable: false },
  { code: "SRV-01", category: "service", name: "Poor support experience", applies_to: ["churn", "exit"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "SRV-02", category: "service", name: "Implementation went badly", applies_to: ["onboarding", "churn", "exit"], needs_competitor: false, recyclable: true, preventable: true },
  { code: "BUS-01", category: "business", name: "Business closed", applies_to: ["churn", "exit"], needs_competitor: false, recyclable: false, preventable: false },
  { code: "BUS-02", category: "business", name: "Merged / acquired", applies_to: ["churn", "exit"], needs_competitor: false, recyclable: true, preventable: false },
  { code: "OTH-01", category: "other", name: "Other (explain in note)", applies_to: ["prospect", "lead", "opportunity", "onboarding", "churn", "exit"], needs_competitor: false, recyclable: true, preventable: false },
];

export const reasonsFor = (point) => reasonCodes.filter((r) => r.applies_to.includes(point));
export const reasonCategory = (key) => reasonCategories.find((c) => c.key === key);
export const reasonByCode = (code) => reasonCodes.find((r) => r.code === code);

export const taskTypes = ["Call", "Email", "Demo", "Visit", "Meeting", "Follow-up", "Review", "Training"];
export const priorities = [
  { key: "low", name: "Low", tone: "secondary" },
  { key: "medium", name: "Medium", tone: "info" },
  { key: "high", name: "High", tone: "warning" },
  { key: "critical", name: "Critical", tone: "danger" },
];
export const communicationTypes = ["Call", "Meeting", "Email", "Visit", "WhatsApp", "Review", "SMS"];
export const documentTypes = ["Contract", "Agreement", "Purchase order", "Proposal", "Quotation", "Implementation evidence", "Sign-off", "UAT report", "Exit letter"];

export const slaPolicies = [
  { priority: "critical", response: "1 hour", resolution: "4 hours", escalate_after: "2 hours", escalate_to: "Head of Support" },
  { priority: "high", response: "4 hours", resolution: "1 business day", escalate_after: "8 hours", escalate_to: "Support Team Lead" },
  { priority: "medium", response: "1 business day", resolution: "3 business days", escalate_after: "2 business days", escalate_to: "Support Team Lead" },
  { priority: "low", response: "2 business days", resolution: "7 business days", escalate_after: "5 business days", escalate_to: "Support Team Lead" },
];

export const staffName = (id) => staff.find((s) => s.id === id)?.name ?? "Unassigned";
export const productName = (id) => products.find((p) => p.id === Number(id))?.name ?? "—";
export const productById = (id) => products.find((p) => p.id === Number(id));
export const productCode = (id) => productById(id)?.code ?? "—";
